// src/components/tasks/ui/TaskDetailDialogUI.tsx
import { cn } from "@/lib/utils"

export const taskDetailDialogTheme = {
  dialogContent: cn(
    "bg-transparent border-0 p-0 max-w-6xl w-full h-[90vh] overflow-hidden",
    // Добавляем лёгкое стекло на весь диалог (если нужно)
    "bg-purple-950/30 backdrop-blur-3xl"
  ),
} as const